const dic = JSON.parse(localStorage.dic);
import { filterTime } from '@/api/filter';
const POLICY_STATUS = dic['POLICY_STATUS'];
const SUPPLIERS = dic['SUPPLIERS'];
const CURRENCY_TYPE = dic['CURRENCY_TYPE'];
const GUARANTEE_TYPE = dic['GUARANTEE_TYPE'];
const PRODUCT_TYPE2 = dic['PRODUCT_TYPE2'];

const SETTLEMENT_STATUS_MAP = { '0': '待结算', '1': '已结算' };
const CHECK_STATUS_MAP = { '1': '待确认', '2': '已确认待打款', '3': '打款成功' };
const INCOME_TYPE_MAP = { '1': '收入', '2': '支出' };


function renderIncomeType(h, params) {
  const type = params.row.incomeType;
  if (!type) return <span>-</span>;
  if (type === '1') return <span style="color: #19be6b">{INCOME_TYPE_MAP[type]}</span>;
  return <span style="color: #ed4014">{INCOME_TYPE_MAP[type]}</span>;
}

function renderRemark(h, params) {
  return <span>{params.row.remark || '-'}</span>;
}

export const config = {
  mixins: [],
  data() {
    return {
      columns: [],
      surroundingColumns: [],
      adjustColumns: []
    };
  },
  methods: {
    getColumns() {
      this.columns = [
        {
          title: '保单编号',
          align: 'center',
          key: 'policyNo',
          minWidth: 160,
          fixed: 'left',
          render(h, params) {
            const icon = params.row.isReferral == 1 && params.row.commissionType == '1' ? <Icon type="md-star" style="margin-right: 4px;" /> : null;
            return <div>{icon}{params.row.policyNo}</div>;
          }
        },
        {
          title: '结算状态',
          align: 'center',
          key: 'settlementStatus',
          minWidth: 120,
          render(h, params) {
            if (params.row.settlementStatus === '0' && params.row.reportName) {
              return <Tag color="orange">待结算</Tag>;
            } else if (params.row.settlementStatus === '1') {
              return <Tag color="green">已结算</Tag>;
            } else {
              return <span>-</span>;
            }
          }
        },
        {
          title: '结算日期',
          align: 'center',
          key: 'settlementDate',
          minWidth: 120,
          render(h, params) {
            return <span>{filterTime(params.row.settlementDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '所属结算报表',
          align: 'center',
          key: 'reportName',
          minWidth: 220,
          render(h, params) {
            return <span>{params.row.reportName || '-'}</span>;
          }
        },
        {
          title: '对账状态',
          align: 'center',
          key: 'checkStatus',
          minWidth: 120,
          render(h, params) {
            const checkStatus = params.row.checkStatus;
            if (params.row.checkStatus === '') return <span>-</span>;
            if (checkStatus === '3') return <Tag color="green">打款成功</Tag>;
            if (checkStatus === '1') return <Tag color="orange">待确认</Tag>;
            return <Tag color="primary">已确认待打款</Tag>;
          }
        },
        {
          title: '打款日期',
          align: 'center',
          key: 'payDate',
          minWidth: 120,
          render(h, params) {
            return <span>{filterTime(params.row.payDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '保单状态',
          align: 'center',
          key: 'policyStatus',
          minWidth: 120,
          render(h, params) {
            return <span>{POLICY_STATUS[params.row.policyStatus]}</span>;
          }
        },
        {
          title: '保单期数',
          align: 'center',
          key: 'commissionIndex',
          minWidth: 120
        },
        {
          title: '签单代理人',
          align: 'center',
          key: 'agentName',
          minWidth: 190,
          renderHeader: (h, params) => {
            return (
              <Poptip trigger="hover" content="content" transfer={true}>
                <span>签单代理人</span>
                <span class="tip-icon">?</span>
                <div slot="content">
                  <p>职级为签单时的职级</p>
                </div>
              </Poptip>
            );
          },
          render(h, params) {
            const ifaLevelMap = { 0: '', 1: '萌新', 2: '新贵', 3: '精英', 4: '王者' };
            return (
              <span>
                {params.row.agentStaffNo + '/' + params.row.agentName}/{ifaLevelMap[params.row.ifaLevel]}
              </span>
            );
          }
        },
        {
          title: '所属团队',
          align: 'center',
          key: 'groupName',
          minWidth: 170
        },
        {
          title: '佣金项类型',
          align: 'center',
          key: 'commissionType',
          minWidth: 120,
          render(h, params) {
            const commissionTypeMap = { 1: '基础销售佣金', 11: '个人Bonus', 12: '管理津贴', 13: '推荐奖', 14: '辅导奖', 15: '育成奖', 16: '育成奖' };
            return <span>{commissionTypeMap[params.row.commissionType]}</span>;
          }
        },
        {
          title: '佣金归属',
          align: 'center',
          key: 'owerName',
          minWidth: 150,
          render(h, params) {
            return <span>{params.row.owerStaffNo + '/' + params.row.owerName}</span>;
          }
        },
        {
          title: '佣金率(%)',
          align: 'center',
          key: 'commission',
          minWidth: 120
        },
        {
          title: '结算汇率',
          align: 'center',
          key: 'settleRate',
          minWidth: 120,
          render(h, params) {
            return <span>{params.row.settleRate || '-'}</span>;
          }
        },
        {
          title: '结算佣金(港币)',
          align: 'center',
          key: 'settleCommissionPrice',
          minWidth: 120,
          render(h, params) {
            return <span>{params.row.settleCommissionPrice || '-'}</span>;
          }
        },
        {
          title: '供应商',
          align: 'center',
          key: 'suppliers',
          minWidth: 120,
          render(h, params) {
            return <span>{SUPPLIERS[params.row.suppliers]}</span>;
          }
        },
        {
          title: '保险公司',
          align: 'center',
          key: 'companyName',
          minWidth: 120
        },
        {
          title: '产品名称',
          align: 'center',
          key: 'productName',
          minWidth: 180
        },
        {
          title: '产品类型',
          align: 'center',
          key: 'productType',
          minWidth: 120,
          render(h, params) {
            return <span>{PRODUCT_TYPE2[params.row.productType]}</span>;
          }
        },
        {
          title: '签单日期',
          align: 'center',
          key: 'signDate',
          minWidth: 120,
          render(h, params) {
            return <span>{filterTime(params.row.signDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '生效日期',
          align: 'center',
          key: 'effectDate',
          minWidth: 120,
          render(h, params) {
            return <span>{filterTime(params.row.effectDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '冷静期截止日',
          align: 'center',
          key: 'expirationDate',
          minWidth: 120,
          render(h, params) {
            return <span>{filterTime(params.row.expirationDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '投保人/受保人',
          align: 'center',
          key: 'holderName',
          minWidth: 180,
          render(h, params) {
            return (
              <span>
                {params.row.holderName || '-'}/{params.row.insuranceName || '-'}
              </span>
            );
          }
        },
        {
          title: '受保人年龄',
          align: 'center',
          key: 'insuranceAge',
          minWidth: 100
        },
        {
          title: '年缴保费',
          align: 'center',
          key: 'fee',
          minWidth: 180,
          render(h, params) {
            let paymentType = params.row.paymentType;
            let periodUnit = GUARANTEE_TYPE[paymentType] || '年';
            return (
              <span>
                {params.row.fee}{CURRENCY_TYPE[params.row.currencyType]}/{params.row.paymentPeriod}{periodUnit}
              </span>
            );
          }
        }
      ];

      this.surroundingColumns = [
        { title: 'IFA', align: 'center', key: 'owerName', minWidth: 150},
        { title: '保单编号', align: 'center', key: 'policyNo', minWidth: 140 },
        { title: '结算日期', align: 'center', key: 'settlementDate', minWidth: 120, render(h, params) { return <span>{filterTime(params.row.settlementDate, 'YYYY-MM-DD')}</span>; } },
        { title: '积分（港币）', align: 'center', key: 'commissionPrice', minWidth: 120 },
        {
          title: '结算状态',
          align: 'center',
          key: 'settlementStatus',
          minWidth: 100,
          render(h, params) {
            const status = params.row.settlementStatus;
            if (status === '0') return <Tag color="orange">{SETTLEMENT_STATUS_MAP[status]}</Tag>;
            if (status === '1') return <Tag color="green">{SETTLEMENT_STATUS_MAP[status]}</Tag>;
            return <span>-</span>;
          }
        },
        {
          title: '对账状态',
          align: 'center',
          key: 'checkStatus',
          minWidth: 120,
          render(h, params) {
            const status = params.row.checkStatus;
            if (!status) return <span>-</span>;
            if (status === '3') return <Tag color="green">{CHECK_STATUS_MAP[status]}</Tag>;
            if (status === '1') return <Tag color="orange">{CHECK_STATUS_MAP[status]}</Tag>;
            return <Tag color="primary">{CHECK_STATUS_MAP[status]}</Tag>;
          }
        },
        { title: '收支类型', align: 'center', key: 'incomeType', minWidth: 100, render: renderIncomeType },
        { title: '备注', align: 'center', key: 'remark', minWidth: 180, render: renderRemark },
        {
          title: '操作',
          align: 'center',
          key: 'action',
          minWidth: 140,
          fixed: 'right',
          render: (h, params) => {
            const isSettled = params.row.settlementStatus === '1';
            const hasSettlementDate = !!params.row.settlementDate;
            const disabled = isSettled || hasSettlementDate;
            const deleteBtn = <span class="table-btn" style={disabled ? 'color: #c5c8ce; cursor: not-allowed' : 'color: #ed4014'} onClick={() => !disabled && this.handleDelete(params.row)}>删除</span>;
            const editBtn = <span class="table-btn" style={disabled ? 'color: #c5c8ce; cursor: not-allowed' : ''} onClick={() => !disabled && this.handleEdit(params.row)}>编辑</span>;
            return (
              <div>
                {disabled ? <Tooltip transfer content="已加入结算单或已结算数据禁止编辑" placement="top">{editBtn}</Tooltip> : editBtn}
                {disabled ? <Tooltip transfer content="已加入结算单或已结算数据禁止删除" placement="top">{deleteBtn}</Tooltip> : deleteBtn}
              </div>
            );
          }
        }
      ];

      this.adjustColumns = [
        { title: 'IFA', align: 'center', key: 'owerName', minWidth: 150 },
        { title: '保单编号', align: 'center', key: 'policyNo', minWidth: 140 },
        { title: '结算日期', align: 'center', key: 'settlementDate', minWidth: 120, render(h, params) { return <span>{filterTime(params.row.settlementDate, 'YYYY-MM-DD')}</span>; } },
        { title: '积分（港币）', align: 'center', key: 'commissionPrice', minWidth: 120 },
        {
          title: '结算状态',
          align: 'center',
          key: 'settlementStatus',
          minWidth: 100,
          render(h, params) {
            const status = params.row.settlementStatus;
            if (status === '0') return <Tag color="orange">{SETTLEMENT_STATUS_MAP[status]}</Tag>;
            if (status === '1') return <Tag color="green">{SETTLEMENT_STATUS_MAP[status]}</Tag>;
            return <span>-</span>;
          }
        },
        {
          title: '对账状态',
          align: 'center',
          key: 'checkStatus',
          minWidth: 120,
          render(h, params) {
            const status = params.row.checkStatus;
            if (!status) return <span>-</span>;
            if (status === '3') return <Tag color="green">{CHECK_STATUS_MAP[status]}</Tag>;
            if (status === '1') return <Tag color="orange">{CHECK_STATUS_MAP[status]}</Tag>;
            return <Tag color="primary">{CHECK_STATUS_MAP[status]}</Tag>;
          }
        },
        { title: '收支类型', align: 'center', key: 'incomeType', minWidth: 100, render: renderIncomeType },
        { title: '备注', align: 'center', key: 'remark', minWidth: 180, render: renderRemark },
        {
          title: '操作',
          align: 'center',
          key: 'action',
          minWidth: 140,
          fixed: 'right',
          render: (h, params) => {
            const isSettled = params.row.settlementStatus === '1';
            const hasSettlementDate = !!params.row.settlementDate;
            const disabled = isSettled || hasSettlementDate;
            const deleteBtn = <span class="table-btn" style={disabled ? 'color: #c5c8ce; cursor: not-allowed' : 'color: #ed4014'} onClick={() => !disabled && this.handleDelete(params.row)}>删除</span>;
            const editBtn = <span class="table-btn" style={disabled ? 'color: #c5c8ce; cursor: not-allowed' : ''} onClick={() => !disabled && this.handleEdit(params.row)}>编辑</span>;
            return (
              <div>
                {disabled ? <Tooltip transfer content="已加入结算单或已结算数据禁止编辑" placement="top">{editBtn}</Tooltip> : editBtn}
                {disabled ? <Tooltip transfer content="已加入结算单或已结算数据禁止删除" placement="top">{deleteBtn}</Tooltip> : deleteBtn}
              </div>
            );
          }
        }
      ];
    }
  }
};
